import axios from "axios";
import { apibasePath } from "./config.jsx";

const fetchData = async (endpoint, method, body) => {
  try {
    const token = localStorage.getItem("token");
    // const res = await axios.get(`${apibasePath}/${endpoint}`,{
    //     headers: {
    //         Authorization: `bearer ${token}`
    //     },
    //     body,
    // });

    const options = {
      method,
      headers: {
        Authorization: `bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    if (method !== "GET"   && body) {
      options.body = JSON.stringify(body);
    }

    const res = await fetch(`${apibasePath}/${endpoint}`, options);
    const data = await res.json();
    // console.log(res.json())

    if (res.ok) {
      return data;
    } else {
      return {error:res.statusText};
    }
  } catch (error) {
    console.log("Error Fetching", error)
    return {error: error};
  }
};

export const searchByTag = async (tag) => {
  return fetchData(`client/item-stock-by-tag/${tag}/`, "GET");
};

export const DeleteByTag = async (body ) => {
  return fetchData(`client/delete-by-tag/`, "DELETE", body);
};

export const addCartByTag = async (body) => {
  return fetchData(`client/add-to-cart-by-item-tag/`, "POST", body);
};

export const cartCountfeatchData = async () => {
  return fetchData(`client/cart-count/`, "GET");
};

export const fetchOrderStock = async () => {
  return fetchData(`client/customer-item-order-stock-list/`, "GET");
};

export const fetchReadyStock = async () => {
  return fetchData(`client/customer-item-stock-list/`, "GET");
};


export const fetchReadyStockSizes = async (body) => {
  return fetchData(`client/item-available-sizes/`, "POST",body);
};

export const fetchOrderStockSizes = async () => {
  return fetchData(`client/order-stock-available-sizes/`, "GET");
};

export const fetchCart = async () => {
  return fetchData(`client/customer-cart-details/`, "GET");
};

export const addToCart = async (body) => {
  return fetchData(`client/cart/add/`, "POST",body);
};

export const fetchCustonerItems = async () => {
  return fetchData(`client/customer-items/`, "GET");
};

export const AddRemark = async (id,body) => {
  return fetchData(`client/cart/update/${id}/`, "PUT", body);
};

//admin

export const DelOrderItem = async (id) => {
  return fetchData(`order/order-items/create/${id}/`, "DELETE");
};

export const GetExistCustomer = async (code) => {
  return fetchData(`order/customer/${code}/`, "GET");
};

export const createCustomerCall = async (  body) => {
  return fetchData(`order/create-customer/`, "POST", body);
};

export const EditCustomer = async (code, body) => {
  return fetchData(`order/customer/${code}/`, "PUT", body);
};
export const DeleteCustomer = async (code) => {
  return fetchData(`order/customer/${code}/`, "DELETE");
};

export const GetAllCustomers = async (code) => {
  return fetchData(`order/all-customers/`, "GET");
};


//remarks, quantitty
export const EditOrderItem  = async (id, body) => {
  return fetchData(`order/order-items/create/${id}/`, "PUT", body);
};

//fetch company name  logo

export const GetCompanyDetails = async (code) => {
  return fetchData(`client/profiles/company/`, "GET");
};

//fetch brand name logo
export const GetBrandDetails = async (code) => {
  return fetchData(`client/profiles/brand/`, "GET");
};
